import React from 'react'
import PropTypes from 'prop-types'

const leafSVG = ({ color, width, height }) => (
    <svg viewBox="0 0 24 24" width={width} height={height}>
        <g>
            <path d=" M 6.773 22.577 C 5.168 22.399 4.455 21.864 3.92 21.329 C 4.098 19.902 4.811 18.832 5.524 17.227 C 5.881 16.157 6.416 15.266 7.129 14.731 C 7.843 14.018 8.556 13.483 9.269 12.948 C 10.517 12.056 11.766 11.699 12.122 11.521 C 12.479 11.343 13.192 11.164 14.084 10.808 C 14.797 10.451 15.867 10.094 16.759 9.738 C 18.542 8.846 19.434 7.063 19.434 7.063 C 19.434 7.063 17.829 7.955 16.045 8.49 C 15.154 8.846 14.262 9.203 13.371 9.381 C 12.479 9.559 11.766 9.738 11.409 9.916 C 10.696 10.094 6.238 11.521 3.92 15.801 C 3.385 17.049 3.028 18.119 2.85 19.189 C 2.315 19.011 1.601 18.476 1.601 17.406 C 1.245 15.801 1.423 10.808 6.238 8.133 C 11.231 5.28 16.759 5.815 19.434 5.101 C 21.93 4.21 23 1 23 1 C 23 1 23 21.15 6.773 22.577 Z "
                  fill={color}/>
        </g>
    </svg>
)

leafSVG.defaultProps = {
    color: '#8AC43F',
    width: 24,
    height: 24,
}

leafSVG.propTypes = {
    color: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
}

export default (leafSVG)
